module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedMedium.040d0b6.woff2";